import React from 'react';

// Decorative brand-blue wave for the hero (replaces the template's purple illustration-section-01.svg).
const MkWave = ({ className }) => (
  <svg
    className={['mk-wave', className].filter(Boolean).join(' ')}
    width="720"
    height="220"
    viewBox="0 0 720 220"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <linearGradient id="mk-wave-grad" x1="0" y1="0" x2="720" y2="0" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#47B9EB" />
        <stop offset="1" stopColor="#267DF3" />
      </linearGradient>
    </defs>
    <path
      d="M0 150C120 150 170 60 300 70S470 190 590 150 690 40 720 30"
      stroke="url(#mk-wave-grad)"
      strokeWidth="1.5"
      opacity=".35"
      fill="none"
    />
    <path
      d="M0 185C140 180 200 100 320 108S480 210 610 176 700 80 720 72"
      stroke="url(#mk-wave-grad)"
      strokeWidth="1.5"
      opacity=".35"
      fill="none"
    />
  </svg>
);

export default MkWave;
